import React, { useMemo, useState } from 'react';
import {
  IonButton,
  IonButtons,
  IonIcon,
  IonImg,
  IonLabel,
  IonList,
  IonTabButton,
  useIonViewDidEnter,
} from '@ionic/react';
import { useParams } from 'react-router';
import { heartCircleOutline, refresh } from 'ionicons/icons';
import LoyaltyPgMyOffers from 'containers/loyalty/loyaltyPgMyOffers';
import LoyaltyPgDetail from 'containers/loyalty/loyaltyPgDetail';
import { PageLayout } from 'containers/layout';
import { useSelector, useDispatch } from 'react-redux';
import PayActions, { PaySelectors } from 'redux/PayRedux';
import { useLocation } from 'react-router-dom';

export const TAB_PROGRAM_MY_OFFERS = 'loyalty_program_my_offers';
export const TAB_PROGRAM_DETAIL = 'loyalty_explore_programs';

function LoyaltyDetail() {
  const location = useLocation();
  const params = useParams();
  const dispatch = useDispatch();

  const { programId } = params;

  const [tabItem, setTabItem] = useState(TAB_PROGRAM_MY_OFFERS);

  useIonViewDidEnter(() => {
    dispatch(PayActions.loadRewardLevels(false));
    dispatch(PayActions.loadLoyaltyPoints());
    dispatch(PayActions.loadLoyaltyAutoOffers(programId));
  });

  const loyaltyPrograms = useSelector(PaySelectors.selectLoyaltyPrograms);

  const currentProgramInfo = useMemo(() => {
    const filterProgram = loyaltyPrograms.filter(item => item.id === programId);

    if (filterProgram.length > 0) {
      return filterProgram[0];
    }

    return null;
  }, [loyaltyPrograms, programId]);

  return (
    <PageLayout
      title={currentProgramInfo?.name}
      back="/loyalty"
      header={
        <IonButtons slot="end">
          <IonButton onClick={() => {
            dispatch(PayActions.loadRewardLevels());
            dispatch(PayActions.loadLoyaltyPoints());
            dispatch(PayActions.loadLoyaltyAutoOffers(programId));
          }}
          >
            <IonIcon slot="icon-only" icon={refresh} />
          </IonButton>
        </IonButtons>
      }
      footer={
        !location.state?.hideBottomMenu && (
          <IonList className="tab-bar-wrap">
            <IonButtons slot="bottom">
              <IonTabButton onClick={() => setTabItem(TAB_PROGRAM_MY_OFFERS)} selected={tabItem === TAB_PROGRAM_MY_OFFERS}>
                <div className={`tab-button-coin-wrap ${tabItem === TAB_PROGRAM_MY_OFFERS && "tab-button-selected-coin-wrap"}`}>
                  <IonImg src="/assets/vemos-coin.png" className="tab-coin-img-icon" />
                </div>
                <IonLabel className="tab-button-text-label">My Offers</IonLabel>
              </IonTabButton>

              <IonTabButton onClick={() => setTabItem(TAB_PROGRAM_DETAIL)} selected={tabItem === TAB_PROGRAM_DETAIL}>
                <IonIcon icon={heartCircleOutline} />
                <IonLabel className="tab-button-text-label">Program Detail</IonLabel>
              </IonTabButton>
            </IonButtons>
          </IonList>
        )
      }
    >
      {
        !location.state?.hideBottomMenu && tabItem === TAB_PROGRAM_MY_OFFERS ? <LoyaltyPgMyOffers programId={programId} showModal={location.state?.showBirthdayModal} /> : <LoyaltyPgDetail programId={programId} />
      }

    </PageLayout>
  );
}

export default LoyaltyDetail;
